import type { ReactNode } from "react";
import type { Role } from "@app-types/activity-data.types";
import {
  AccountTreeOutlined,
  BarChartOutlined,
  BusinessCenterOutlined,
  CalendarMonthOutlined,
  PanToolOutlined,
  TerminalOutlined,
} from "@mui/icons-material";

export const roleDetails: Record<
  Role,
  { label: string; description: string; icon: ReactNode }
> = {
  "product-analyst-ux": {
    label: "UX",
    description: "User journeys, UI patterns, Figma mockups",
    icon: <PanToolOutlined />,
  },
  "enabling-teams": {
    label: "Enabling team",
    description: "People operations, GTM strategy, enablement",
    icon: <BusinessCenterOutlined />,
  },
  "product-developers-engineers": {
    label: "Engineers",
    description: "Code architecture, feature builds, pull requests",
    icon: <TerminalOutlined />,
  },
  data: {
    label: "Data Consultants & Engineers",
    description: "Engagement loops, queries, metrics",
    icon: <BarChartOutlined />,
  },
  "product-analyst-delivery": {
    label: "Delivery Manager",
    description: "Sprint cycles, milestone tracking, velocity",
    icon: <CalendarMonthOutlined />,
  },
  "product-analyst-product": {
    label: "Product Analyst",
    description: "Resource allocation, stakeholder alignment",
    icon: <AccountTreeOutlined />,
  },
};
